import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Layout from "../layout/Layout";
import { useEffect, useState } from "react";
import { obtenerMesActual } from "../utils/categoriasConEmoji";

export default function AddExtra() {
    const [mes, setMes] = useState(obtenerMesActual);
    const [extras, setExtras] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const getList = async () => {
        const res = await axios.get(
            `${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/extras/list?mes=${mes}`,
            { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );

        if (res.data.success) {
            setExtras(res.data.data);
        } else {
            alert("Error al obtener gastos");
        }
    }
    useEffect(() => {
        getList();
    }, [mes])


    const formik = useFormik({
        initialValues: {
            nombre: "",
            monto: "",
            mes: ""
        },
        validationSchema: Yup.object({
            nombre: Yup.string().required("Nombre del ingreso requerido"),
            monto: Yup.number().min(1, "Debe ser mayor a 0").required("Monto requerido"),
            mes: Yup.string().required("Selecciona el mes"),
        }),
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            try {
                const res = await axios.post(
                    `${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/extras`,
                    {
                        ...values,
                        monto: parseFloat(values.monto)
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`
                        }
                    }
                );

                if (res.data.success) {
                    alert("Ingreso extra registrado 🎉");
                    resetForm();
                } else {
                    alert("No se pudo guardar el ingreso 😢");
                }
            } catch (error) {
                console.error(error);
                alert("Error al conectar con el servidor");
            } finally {
                setSubmitting(false);
            }
        }
    });

    return (
        <Layout>
            <section>
                <div className="container text-center">
                    <div className="row">
                        <div className="col">

                            <div className="div-card">
                                <h4>Agregar ingreso extra</h4>
                                <form onSubmit={formik.handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Nombre del ingreso:</label>
                                        <input
                                            type="text"
                                            name="nombre"
                                            className="form-control"
                                            value={formik.values.nombre}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.nombre && formik.errors.nombre && (
                                            <p style={{ color: "red" }}>{formik.errors.nombre}</p>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Monto:</label>
                                        <input
                                            type="number"
                                            name="monto"
                                            className="form-control"
                                            value={formik.values.monto}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.monto && formik.errors.monto && (
                                            <p style={{ color: "red" }}>{formik.errors.monto}</p>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Mes:</label>
                                        <input
                                            type="month"
                                            name="mes"
                                            className="form-control"
                                            value={formik.values.mes}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.mes && formik.errors.mes && (
                                            <p style={{ color: "red" }}>{formik.errors.mes}</p>
                                        )}
                                    </div>

                                    <button className="btn btn-warning" type="submit" disabled={formik.isSubmitting}>
                                        {formik.isSubmitting ? "Guardando..." : "Agregar ingreso"}
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div className="col">
                            <div className="div-card">

                                <label>Selecciona mes: </label>
                                <input
                                    type="month"
                                    value={mes}
                                    className="form-control"
                                    onChange={(e) => setMes(e.target.value)}
                                />

                                {
                                    (extras.length === 0) ?
                                        <>No hay nada</>
                                        :
                                        (
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">nombre</th>
                                                        <th scope="col">monto</th>
                                                        <th scope="col">mes</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        extras.map((item, index) => {
                                                            return (
                                                                <tr key={`extra-${index}`}>
                                                                    <td >{item.nombre}</td>
                                                                    <td>{item.monto}</td>
                                                                    <td>{item.mes}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
}
